// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"477a8aee","732":"8f8ff023","977":"99e6fb6d"}[chunkId] + ".chunk.js";
};